export const refs = {
  furnitureModal: document.querySelector('.js-furniture-modal'),
  mobileMenu: document.querySelector('[data-mobile-menu]'),
};
